import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import BlockFactory from './BlockFactory';
import BlockEditHeader from './BlockEditHeader';
import BlockEditFooter from './BlockEditFooter';

import ColorPallet from './ColorPallet';

import fontSizeIcon from "icons/drawable/폰트사이즈-아이콘.svg";
import lineHeightIcon from "icons/drawable/줄간격_아이콘.svg";

import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const HEADERS = [ '본문', '소제목', '중제목', '대제목' ];
const FONT_FAMILIES = [
	"노토산스 Regular", "노토산스 Medium", "노토산스 Light", "노토산스 Bold", "노토산스 Black",
	"노토세리프 Regular", "노토세리프 Medium", "노토세리프 Light", "노토세리프 Bold", "노토세리프 Black",
	"다시 시작해", "배민 주아체", "우리딸 손글씨", "카페24써라운드에어", "배민 을지로체",
	"여기어때잘난체", "카페24숑숑", "카페24써라운드",
];
const FONT_SIZES = [ "10", "11", "12", "14", "18", "24", "32", "42"];
const LINE_HEIGHTS = [ "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"];

function headerValue(header) {
	return (HEADERS.length - HEADERS.indexOf(header)).toString();
}

function fontFamilyValue(fontFamily) {
	return fontFamily;
}

function fontSizeValue(fontSize) {
	return `${Math.round(parseInt(fontSize)/360 * 10000) / 100}vw`;
}

function lineHeightValue(lineHeight) {
	return `${Math.round(parseInt(lineHeight)/360 * 10000) / 100}vw`;
}

function setEditorDefaultStyle(style) {
	//style.header = headerValue(HEADERS[3]);
	//style.fontFamily = fontFamilyValue(FONT_FAMILIES[10]);
	//style.fontSize = fontSizeValue(FONT_SIZES[5]);
	//style.lineHeight = lineHeightValue(LINE_HEIGHTS[5]);
	//style.height = `${210/360 * 100}vw`;
	//style.backgroundColor = backgroundColor;
	//style.backgroundRepeat = 'no-repeat';
	//style.backgroundSize = 'cover';
	//style.backgroundAttachment = 'fixed';
	//style.backgroundImage = 'url(https://th.bing.com/th/id/R.4db8527da09487664f0899b2251b7871?rik=DSKcEP3dYAmWTQ&riu=http%3a%2f%2fs1.picswalls.com%2fwallpapers%2f2014%2f01%2f27%2ffree-desktop-background_071551853_19.jpg&ehk=g3MCxDNWTHD%2bT6bVFTDPNoBQB0%2b9q6qlAzhx03YbekM%3d&risl=&pid=ImgRaw&r=0)';
}

const Parchment = Quill.import('parchment');
const lineHeightCfg = {
	scope: Parchment.Scope.BLOCK,
	//whitelist: LINE_HEIGHTS
};
const lineHeightStyle = new Parchment.Attributor.Style('lineheight', 'line-height', lineHeightCfg);
Quill.register(lineHeightStyle, true);

const lineHeightClass = new Parchment.Attributor.Class('lineheight', 'line-height', lineHeightCfg);
Quill.register(lineHeightClass, true);

function TextBlockEditView({idx, iconChar, iconColor, block, onUpdate, onDelete, onDone, onCancel}) {

	console.log("TextBlockEditView()");

	//const [data, setData] = React.useState(block.data);
	//const [textEditMode, /*setTextEditMode*/] = React.useState(true);

	console.log("TextBlockEditView: block.data = " + JSON.stringify(block.data));

	const [optionMode,setOptionMode] = React.useState();
	const [backgroundColor,setBackgroundColor] = React.useState(block.backgroundColor);

	const getUpdatedBlock = (bgColor, newData) => {
		let updatedBlock = BlockFactory.clone(block);
		updatedBlock.backgroundColor = bgColor;
		updatedBlock.backgroundImage = block.backgroundImage;
		updatedBlock.scale = block.scale;
		updatedBlock.translationX = block.translationX;
		updatedBlock.data = newData;
		return updatedBlock;
	};

/*
	const handleEditText = () => {
		//console.log("deltas = " + JSON.stringify(quill.current.getContents()));
		//console.log("html = " + JSON.stringify(quill.current.root.innerHTML));

		if (textEditMode) {
			let newData = quill.current.getContents();
			setData(newData);
			if (onUpdate) {
				onUpdate(getUpdatedBlock(newData, commonStyle));
			}
			setTextEditMode(false);
		}
		else {
			setTextEditMode(true);
		}
	};
*/

	const handleUpdate = () => {
		if (onUpdate) {
			let newData = quill.current.getContents();
			let newStr = JSON.stringify(newData);
			let oldStr = JSON.stringify(quillData.current);

			if (newStr !== oldStr) {
				onUpdate(getUpdatedBlock(backgroundColor, newData));
				quillData.current = newData;
			}
		}
	};

	const handleDelete = () => {
		if (onDelete) {
			onDelete(block);
		}
	};

	const handleDone = () => {
		if (onDone) {
			onDone(getUpdatedBlock(backgroundColor, quill.current.getContents()));
		}
	};

	const handleCancel = () => {
		if (onCancel) {
			onCancel(block);
		}
	};

	const updateEditorStyle = (bgColor) => {
		let editorElm = document.getElementById(getEditorName());
		setEditorDefaultStyle(editorElm.style);
		editorElm.style.height = `${210/360 * 100}vw`;
		editorElm.style.backgroundColor = `${bgColor}`;
		//editorElm.setAttribute('style', editorStyle);
	};

	const handleBackgroundColorChange = (v) => {
		console.log("handleBackgroundColorChange: v = " + v);
		let newBackgroundColor = v;
		setBackgroundColor(newBackgroundColor);

		updateEditorStyle(newBackgroundColor);

		if (onUpdate) {
			onUpdate(getUpdatedBlock(newBackgroundColor, quillData.current));
		}
	};

	const quill = React.useRef();
	const quillData = React.useRef();

/*
	function printChildNodes(mark, id) {
		let target = document.getElementById(id);
		let nodes = target.childNodes;
		console.log(mark + ": # of nodes = " + nodes.length);
		for (let i = 0; i < nodes.length; i++) {
			console.log(nodes[i]);
		}
	}
*/

	function getEditorContainerName() {
		return 'editor-container-' + block.name;
	}

	function getEditorToolbarName() {
		return 'editor-toolbar-' + block.name;
	}

/*
	function getEditorToolbarComponentFullName(compName) {
		return 'editor-toolbar-' + block.name + '-' + compName;
	}
*/

	function getEditorName() {
		return 'editor-' + block.name;
	}

	React.useEffect(() => {
		console.log("TextBlockEditView: useEffect");

		let container = document.getElementById(getEditorContainerName());
		if (container) {
			let editorElm = document.createElement('div');
			editorElm.id = getEditorName();
			setEditorDefaultStyle(editorElm.style);

			container.appendChild(editorElm);

			let options = {
				//debug: 'info',
				modules: {
/*
					toolbar: [
						[{ font: FONT_FAMILIES }, { size: FONT_SIZES }],
						['bold','italic','underline', 'strike'],
						[{ color: [] }, { background: [] }],
						[{script:'sub'},{script:'super'}],
						[{ header: [] }, 'blockquote'],
						[{list: 'ordered'}, {list: 'bullet'}],
						[{indent: "-1"},{indent:"+1"}],
						[{ align: [] }],
						[{ lineheight: LINE_HEIGHTS }],
						//['link', 'image', 'video', 'formula'],
						['clean'],
					]
*/
					toolbar: '#' + getEditorToolbarName(),
				},
				//placeholder: 'Compose an epic...',
				readOnly: false,
				theme: 'snow'
			};

			//console.log("quill options[1] = " + JSON.stringify(options));
			quill.current = new Quill('#' + getEditorName(), options);

/*
			let font = Quill.import('attributors/style/font');
			font.whitelist = fontFamilies;
			Quill.register(font, true);

			let fontSize = Quill.import('attributors/style/size');
			fontSize.whitelist = undefined;
			Quill.register(fontSize, true);

			//console.log("Quill.imports = " + JSON.stringify(Quill.imports));
*/


			let toolbar = quill.current.getModule('toolbar');

/*
			function QuillToolbarCustomizedUpdate(range) {
				let formats = range == null ? {} : this.quill.getFormat(range);
				this.controls.forEach(function(pair) {
					let [format, input] = pair;
					if (input.tagName === 'SELECT') {
						let option;
						if (range == null) {
							option = null;
						} else if (formats[format] == null) {
							console.log("format = " + format);
							//option = input.querySelector('option[selected]');
							//if (!option) console.log("selected option not found");
						} else if (!Array.isArray(formats[format])) {
							let value = formats[format];
							if (typeof value === 'string') {
								value = value.replace(/\"/g, '\\"');
							}
							console.log("format = " + format + ", value = " + value);
							option = input.querySelector(`option[value="${value}"]`);
							if (!option) console.log("option not found");
						}
						if (option == null) {
							// [NOTE] customized portion from original Quill code
							//input.value = '';
							input.selectedIndex = 0;
							//
						} else {
							option.selected = true;
						}
					} else {
						if (range == null) {
							input.classList.remove('ql-active');
						} else if (input.hasAttribute('value')) {
							// both being null should match (default values)
							// '1' should match with 1 (headers)
							let isActive = formats[format] === input.getAttribute('value') ||
								(formats[format] != null && formats[format].toString() === input.getAttribute('value')) ||
								(formats[format] == null && !input.getAttribute('value'));
							input.classList.toggle('ql-active', isActive);
						} else {
							input.classList.toggle('ql-active', formats[format] != null);
						}
					}
				});
			}
			toolbar.update = QuillToolbarCustomizedUpdate.bind(toolbar);
*/


/*
			toolbar.addHandler('size', function (value) {
				let parsed = parseInt(value);
				if (!Number.isNaN(parsed)) {
					//console.log("handler for size: value = " + value);
					let range = quill.current.getSelection();
					//console.log("range = " + JSON.stringify(range));
					let formats = quill.current.getFormat(range);
					//console.log("formats = " + JSON.stringify(formats));
					let converted = `${parsed/360 * 100}vw`;
					//console.log("converted = " + converted);
					let r = quill.current.format('size', converted, Quill.sources.USER);
					//console.log("r = " + JSON.stringify(r));
				}
			});

			toolbar.addHandler('lineheight', function (value) {
				let parsed = parseInt(value);
				if (!Number.isNaN(parsed)) {
					//console.log("handler for lineheight: value = " + value);
					let range = quill.current.getSelection();
					//console.log("range = " + JSON.stringify(range));
					let formats = quill.current.getFormat(range);
					//console.log("formats = " + JSON.stringify(formats));
					let converted = `${parsed/360 * 100}vw`;
					//console.log("converted = " + converted);
					let r = quill.current.format('lineheight', converted, Quill.sources.USER);
					//console.log("r = " + JSON.stringify(r));

				}
			});
*/

			quill.current.on('text-change', function(delta, oldDelta, source) {
				//console.log("oldDelta = " + JSON.stringify(oldDelta) + ", delta = " + JSON.stringify(delta));
				setTimeout(handleUpdate, 0);
			});

			quill.current.on('selection-change', function(range, oldRange, source) {
				if (range) {
					console.log("\n----------------");
					console.log("range = " + JSON.stringify(range));
					let formats = quill.current.getFormat(range);
					console.log("formats = " + JSON.stringify(formats));

					if (formats.size) {
						let trimed = formats.size.substring(0, formats.size.length - 1);
						let converted = Math.round((parseFloat(trimed) / 100) * 360);
						console.log("size = " + converted);
					}
					if (formats.lineheight) {
						let trimed = formats.lineheight.substring(0, formats.lineheight.length - 1);
						let converted = Math.round((parseFloat(trimed) / 100) * 360);
						console.log("lineheight = " + converted);
					}
				}
			});

			quill.current.setContents(block.data);

			//quill.current.root.innerHTML = html;
			quillData.current = quill.current.getContents();

			updateEditorStyle(backgroundColor);
		}

		/* Quill: Read-only mode
		let options = {
			modules: {},
			//placeholder: '텍스트를 입력해주세요.',
			readOnly: true,
		};
		//console.log("quill options[2] = " + JSON.stringify(options));
		quill.current = new Quill('#' + getEditorName(), options);
		quill.current.setContents(data);
		*/
	
		return function cleanup() {
			//console.log("clearing for quill");
			let container = document.getElementById(getEditorContainerName());
			if (container) {
				while (container.firstChild) {
					container.removeChild(container.firstChild);
				}
			}
			quill.current = undefined;
		};

	}, [block.data]);

	const getButtons = () => {
		const btnFontSize = 14;
		const btnTextMargin = -10;

		return (
			<Box
				display='flex'
				flexDirection='row'
				justifyContent='flex-start'
				alignItems='center'
				sx={{
					width:'100%',
					marginTop: `${20/360 * 100}vw`,
				}}
			>
				<Button
					variant="outlined"
					sx={{
						color: "#6cadff",
						bgcolor: optionMode === 'color' ? '#336cadff' : 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${74/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
						marginRight: `${8/360 * 100}vw`,
					}}
					onClick={e => setOptionMode(optionMode === 'color' ? undefined : 'color')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color='#6cadff'
						sx={{margin:`${btnTextMargin}px`}}
					>
						배경색상
					</Typography>
				</Button>
			</Box>
		);
	}

	const getOptionalSetting = () => {
		if (optionMode === 'color') {
			return (
				<ColorPallet curColorValue={backgroundColor} onUpdate={handleBackgroundColorChange}/>
			);
		}
	};

	const getEditorToolbarHeaderSelector = () => {
		const HEADERS_V = HEADERS.map(e => headerValue(e));

		let headerOptions = [];
		for (let i = 0; i < HEADERS.length; i++) {
			let value = headerValue(HEADERS[i]);
			headerOptions.push(<option key={value} value={value}>{HEADERS[i]}</option>);
		}
		return (<select className="ql-header">{headerOptions}</select>);
	};

	const getEditorToolbarFontFamilySelector = () => {
		const FONT_FAMILIES_V = FONT_FAMILIES.map(e => fontFamilyValue(e));

		return (
			<select className="ql-font">
				{FONT_FAMILIES_V.map((e, i) => <option key={e} value={e}>{FONT_FAMILIES[i]}</option>)}
			</select>
		);
	};

	const getEditorToolbarFontSizeSelector = () => {
		const FONT_SIZES_V = FONT_SIZES.map(e => fontSizeValue(e));

		return (
			<Box
				display="flex"
				flexDirection="row"
				alignItems="center"
				style={{ marginLeft: `${5/360 * 100}vw` }}
			>
				<img
					src={fontSizeIcon}
					alt="폰트크기 설정 아이콘"
					style={{
						width: `${10/360 * 100}vw`,
						height: `${10/360 * 100}vw`,
						marginRight: `${-3/360 * 100}vw`,
					}}
				/>
				<select className="ql-size">
				{FONT_SIZES_V.map((e, i) => <option key={e} value={e}>{FONT_SIZES[i]}</option>)}
				</select>
			</Box>
		);
	};

	const getEditorToolbarLineHeightSelector = () => {
		const LINE_HEIGHTS_V = LINE_HEIGHTS.map(e => lineHeightValue(e));

		return (
			<Box
				display="flex"
				flexDirection="row"
				alignItems="center"
				style={{ marginLeft: `${5/360 * 100}vw` }}
			>
				<img
					src={lineHeightIcon}
					alt="줄간격 설정 아이콘"
					style={{
						width: `${10/360 * 100}vw`,
						height: `${10/360 * 100}vw`,
						marginRight: `${-3/360 * 100}vw`,
					}}
				/>
				<select className="ql-lineheight">
				{LINE_HEIGHTS_V.map((e, i) => <option key={e} value={e}>{LINE_HEIGHTS[i]}</option>)}
				</select>
			</Box>
		);
	};

	const getEditorToolbarComponents = () => {
		return (
			<Box
				display="flex"
				flexDirection="row"
				flexWrap="wrap"
				onClick={e => { e.preventDefault(); e.stopPropagation() }}
			>
				{getEditorToolbarHeaderSelector()}
				{getEditorToolbarFontFamilySelector()}
				{getEditorToolbarFontSizeSelector()}

				<Box>
				<select className="ql-color"></select>
				<select className="ql-background"></select>
				<select className="ql-align"></select>
				</Box>

				<Box>
				<button className="ql-bold"></button>
				<button className="ql-italic"></button>
				<button className="ql-underline"></button>
				<button className="ql-strike"></button>
				<button className="ql-script" value="sub"></button>
				<button className="ql-script" value="super"></button>
				</Box>

				<Box>
				<button className="ql-list" value="ordered"></button>
				<button className="ql-list" value="bullet"></button>
				</Box>

				<Box>
				<button className="ql-indent" value="-1"></button>
				<button className="ql-indent" value="+1"></button>
				</Box>

				{getEditorToolbarLineHeightSelector()}
			</Box>
		);
/*
		<button className="ql-blockquote"></button>
		<button className="ql-clean"></button>
*/
	};

	const getBlockContent = () => {
		return (
			<div
				id={getEditorContainerName()}
				style={{
					width:'100%',
					marginTop: `${20/360 * 100}vw`,
				}}
			>
				<div id={getEditorToolbarName()}>
				{getEditorToolbarComponents()}
				</div>
			</div>
		);

/*
		if (!data) {
			return (
				<div
					style={{
						width: '100%',
						height: '100px',
						backgroundColor: 'lightyellow',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<p sx={{color:'black'}}>텍스트를 입력해 주세요</p>
				</div>
			);
		}

		const style = {
			width: '100%',
			paddingTop: commonStyle.padding.top,
			paddingBottom: commonStyle.padding.bottom,
			paddingLeft: commonStyle.padding.left,
			paddingRight: commonStyle.padding.right,
			backgroundColor: commonStyle.bgcolor,
		};

		return (
			<div id={getEditorContainerName()} style={style}/>
		);
*/
	};

/*
	const getEditTextButton = () => {
		return (
			<Box
				display='flex'
				flexDirection='column'
				justifyContent='center'
				alignItems='center'
				sx={{
					width:'100%',
					height:'100px',
					bgcolor:'white',
				}}
			>
				<Button
					variant="contained"
					color="primary"
					size="large"
					onClick={e => handleEditText()}
				>
					{textEditMode ? '수정 완료' : '텍스트 수정'}
				</Button>
			</Box>
		);
	};
*/

	return (
		<Box
			display='flex'
			flexDirection='column'
			justifyContent='center'
			alignItems='center'
			sx={{
				left:`${20/360 * 100}vw`,
				width:`${320/360 * 100}vw`,
			}}
			onContextMenu={e => e.stopPropagation() /* to allow context menu for text edit block */}
		>
			<BlockEditHeader
				blockName={block.name}
				iconChar={iconChar}
				iconColor={iconColor}
				onDelete={onDelete ? () => handleDelete() : undefined}
			/>
			{getButtons()}
			{getOptionalSetting()}
			{getBlockContent()}
			{
				onDone && onCancel &&
				<BlockEditFooter
					blockName={block.name}
					onDone={() => handleDone()}
					onCancel={() => handleCancel()}
				/>
			}
		</Box>
	);
}

export default TextBlockEditView;
